const holder = {
  closeDateRangeSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener("mousedown", holder.closeDateRangeSelector)
    }
  }
};

export default {
  refreshOn: ({ startDate, endDate }) => ([startDate, endDate]),
  'DateRangeSelector.Selector': ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter
    holder.containerRef = containerRef
    internalStateSetter({ isOpen: !isOpen });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDateRangeSelector);
    } else {
      document.addEventListener("mousedown", holder.closeDateRangeSelector);
    }
  },

  'DateRangeSelector.Selector.Inputs.StartDateInput': ({ value }, _, internalStateSetter) => {
    internalStateSetter('startDateEntry', value);
  },

  'DateRangeSelector.Selector.Inputs.StartDateInput(Keydown)': ({ value, key, endDate }, outlet, internalStateSetter) => {
    if (key === 'Enter') {
      let arr = value.split('/');

      var selectedDate = new Date(arr[2], arr[0] - 1, arr[1]);
      if (selectedDate > endDate) {
        internalStateSetter({ startDate: selectedDate, endDate: selectedDate, startDateEntry: null })
        outlet({ startDate: selectedDate, endDate: selectedDate })
      } else {
        internalStateSetter({ startDate: selectedDate, endDate, startDateEntry: null })
        outlet({ startDate: selectedDate, endDate })
      }
    }
  },

  'DateRangeSelector.Selector.Inputs.EndDateInput': ({ value }, _, internalStateSetter) => {
    internalStateSetter('endDateEntry', value);
  },

  'DateRangeSelector.Selector.Inputs.EndDateInput(Keydown)': ({ value, key, startDate }, outlet, internalStateSetter) => {
    if (key === 'Enter') {
      let arr = value.split('/');

      var selectedDate = new Date(arr[2], arr[0] - 1, arr[1]);
      if (selectedDate < startDate) {
        internalStateSetter({ startDate: selectedDate, endDate: selectedDate, endDateEntry: null })
        outlet({ startDate: selectedDate, endDate: selectedDate })
      } else {
        internalStateSetter({ startDate, endDate: selectedDate, endDateEntry: null })
        outlet({ startDate, endDate: selectedDate })
      }
    }
  },

  'DateRangeSelector.Body.StartCalendar': ({ selectedDate, disabledAfter }, outlet, internalStateSetter) => {
    if (selectedDate > disabledAfter) {
      internalStateSetter({ startDate: selectedDate, endDate: selectedDate })
      outlet({ startDate: selectedDate, endDate: selectedDate })
    } else {
      internalStateSetter({ startDate: selectedDate })
      outlet({ startDate: selectedDate, endDate: disabledAfter })
    }
  },

  'DateRangeSelector.Body.EndCalendar': ({ selectedDate, disabledBefore }, outlet, internalStateSetter) => {
    if (selectedDate < disabledBefore) {
      internalStateSetter({ startDate: selectedDate, endDate: selectedDate })
      outlet({ startDate: selectedDate, endDate: selectedDate })
    } else {
      internalStateSetter({ endDate: selectedDate })
      outlet({ startDate: disabledBefore, endDate: selectedDate })
    }
  },
}